function isContain(arr, element) {  
	if(!arr) return false;
    for (var i = 0; i < arr.length; i++) { 
        if (arr[i] == element) {  
            return true; 
        }
    }
    return false; 
}

module.exports = {
	isContain,
}


// WEBPACK FOOTER //
// ../src4js/pc4backstage/portal4engine/util/common.js